import { Component, HostListener, OnInit } from '@angular/core';
import { CoreData } from './tools/core-data';
import { LoadingTask } from './tools/loading-task';
import { ActivationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ENavigationRoute } from './models/enum/navigation-route';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    constructor(
        private router: Router,
        private coreData: CoreData,
        public loadingTask: LoadingTask) {
        this.coreData.getTypeOfDevice();
        // this.testLocalStorage();
    }
    ngOnInit(): void {
        this.router.events
            .pipe(filter((e: any) => e instanceof ActivationEnd)
            ).subscribe((e: ActivationEnd) => {
                const url = e.snapshot.url.length > 0 ? e.snapshot.url[0].path : '/';
                console.log(e.snapshot.url)
                // console.log(this.coreData.IsInverventionSelected)
                if (url as ENavigationRoute === ENavigationRoute.InterventionDashboard ||
                    url as ENavigationRoute === ENavigationRoute.DescriptionStation ||
                    url as ENavigationRoute === ENavigationRoute.Photo ||
                    url as ENavigationRoute === ENavigationRoute.PlanPrelevement ||
                    url as ENavigationRoute === ENavigationRoute.IBD ||
                    url as ENavigationRoute === ENavigationRoute.IBGN ||
                    url as ENavigationRoute === ENavigationRoute.IBMR ||
                    url as ENavigationRoute === ENavigationRoute.MGCE ||
                    url as ENavigationRoute === ENavigationRoute.MPCE ||
                    url as ENavigationRoute === ENavigationRoute.EAU ||
                    url as ENavigationRoute === ENavigationRoute.IML ||
                    url as ENavigationRoute === ENavigationRoute.LAC) {
                    this.coreData.IsInverventionSelected = true;
                }
                else
                    this.coreData.IsInverventionSelected = false;
            });
    }

    @HostListener('window:beforeunload', ['$event'])
    unloadHandler(event: BeforeUnloadEvent) {

        console.log('BEFOREUNLOAD');
        event.preventDefault();
        event.returnValue = false;
        return event;
    }

    testLocalStorage() {

        if (localStorage && !localStorage.getItem('size')) {
            var i = 0;
            try {
                // Test up to 10 MB
                for (i = 10; i <= 10000; i += 10) {
                    localStorage.setItem('test', new Array((i * 1024) + 1).join('a'));
                }
            } catch (e) {
                // localStorage.removeItem('test');
                localStorage.setItem('size', `${i - 10}`);
            }
        }
    }
}
